import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useCustomPageDispatch } from "./custom-page-context";

export const useCustomPageController = () => {
    const customPageDispatch = useCustomPageDispatch();

    async function loadArticle(id: number) {
        try {
            customPageDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.getArticleById(id);

            customPageDispatch({
                type: ACTION_TYPES.setDetail,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar artigo:', error);
            customPageDispatch({
                type: ACTION_TYPES.setError,
                payload: 'Erro ao carregar o artigo. Por favor, tente novamente.',
            });
        }
    }

    async function loadCustomPage(slug: string) {
        try {
            customPageDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.getCustomPage(slug);

            customPageDispatch({
                type: ACTION_TYPES.setPage,
                payload: result,
            });
        } catch (error: any) {
            // Página despublicada, excluída ou slug alterado: a API responde 404
            if (error?.response?.status === 404) {
                customPageDispatch({ type: ACTION_TYPES.setNotFound });
                return;
            }
            console.error('Erro ao carregar página:', error);
            customPageDispatch({
                type: ACTION_TYPES.setError,
                payload: 'Erro ao carregar a página. Por favor, tente novamente.',
            });
        }
    }

    return {
        loadArticle,
        loadCustomPage
    };
};
